import {immerable} from "immer";
import Measure from "./measure.ts";

class StoreyMeasures {
    [immerable] = true;
    
    id: string;
    
    name: string;
    
    index: number;
    
    altimetry: number;
    
    measures: Measure[] = [];
    
    constructor(id: string, name: string, index: number, altimetry: number) {
        this.id = id;
        this.name = name;
        this.index = index;
        this.altimetry = altimetry;
    }
    
    public editMeasure(id: string, measure: Measure): void {
        const targetMeasure = this.measures.find(m => m.measureId === id);
        if(targetMeasure == null) return;
        targetMeasure.editMeasure(measure);
    }
}

export default StoreyMeasures;